import React from "react";
import {
  CardBody,
  Card,
  Label,
  Col,
  Button,
  Row,
} from "reactstrap";
import withRouter from "../../../../../withRouter";
import { connect } from "react-redux";
import moment from "moment";
import Select from "react-select";
import { getUserInfo } from "../../../../../helper";
import {
  downloadEWSReportRequest,
  ewsPublishListRequest,
  fetchCorporateEwsRequest,
} from "../../action";
import {
  listEwsReport,
  listEwsReportSuccess,
  listEwsReportFailure,
} from "./action";
import fileSaver from "file-saver";
import { toast } from "react-toastify";
import { Preloading as preloading } from "../../../../../components/UI/Preloader/action";
import "./ewsReport.scss"
import Table from "../table";
import ComplianceCheckScoreTable from "./complianceCheckScoreTable/index";

const portfolioOptions = [
  { value: "Portfolio", label: "Portfolio" },
  { value: "Non Portfolio", label: "Non Portfolio" },
];

class EwsReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userData: {},
      portfolioSelectedOption: null,
      isPortfolio: undefined,
      selectedPublish: null,
      publishList: [],
      scoreData: {},
      avgDelayData: {},
      currentDelayData: {},
      companyStatusData: {},
      comapnyComplianceData: {},
      shortTermRating: {},
      selectedPublishRow:{},
      columnsForPortfolio:[
        { Header: "Corporate Name", accessor: "corporateName", },
        { Header: "Counterparty Name", accessor: "counterpartyName", 
        filterMethod: (filter, row) => {
          const id = filter.pivotId || filter.id;
          return row[id] !== undefined
            ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase())
            : true;
        },
        Filter: ({ filter, onChange }) => (
          <input
            onChange={(event) => onChange(event.target.value)}
            value={filter ? filter.value : ''}
            placeholder="Search..."
          />),
        },
        {
          Header: "Pan Number",
          accessor: "panNo",
        },
        {
          Header: "Date of Business Check Report",
          accessor: "dateOfBusinessCheck"
        },
        {
          Header: "Rubix Business Check Score",
          accessor: "latestRubixScore",
        },
        {
          Header: "Current Rubix Business Check Score After EWS",
          accessor: "latestEwsScore",
        },
        {
          Header: "Previous Rubix Business Check Score After EWS",
          accessor: "previousEwsScore",
        },
        { Header: "Change", accessor: "changeInScore",
        Cell: ({ value}) =>{ 
          return (
          <span>
            {(value && value != 0) && <i className={value < 0 ? "fa fa-caret-down changeCaretDown" : "fa fa-caret-up changeCaretUp"} style={{ color: value < 0 ? 'red' : 'green' }}></i>}{Math.abs(value)}
          </span>
        )},
      },
      {expander:true}

      ],

      columnsForNonPortfolio:[
        { Header: "Corporate Name", accessor: "corporateName", },
        { Header: "Counterparty Name", accessor: "counterpartyName", 
        filterMethod: (filter, row) => {
          const id = filter.pivotId || filter.id;
          return row[id] !== undefined
            ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase())
            : true;
        },
        Filter: ({ filter, onChange }) => (
          <input
            onChange={(event) => onChange(event.target.value)}
            value={filter ? filter.value : ''}
            placeholder="Search..."
          />),
        },
        {
          Header: "Pan Number",
          accessor: "panNo",
        },
        {
          Header: "Current Rubix Business Check Score After EWS",
          accessor: "latestEwsScore",
        },
        {
          Header: "Previous Rubix Business Check Score After EWS",
          accessor: "previousEwsScore",
        },
        { Header: "Change", accessor: "changeInScore",
        Cell: ({ value}) =>{ 
          return (
          <span>
            {(value && value != 0) && <i className={value < 0 ? "fa fa-caret-down changeCaretDown" : "fa fa-caret-up changeCaretUp"} style={{ color: value < 0 ? 'red' : 'green' }}></i>}{Math.abs(value)}
          </span>
        )},
      },
      {expander:true}

      ],
      columnsForDropdown: [
        {
          label: "Rubix Business Check Score",
          value: "latestRubixScore",
        },
        {
          label: "Current Rubix Business Check Score After EWS",
          value: "latestEwsScore"
        },
        {
          label: "Previous Rubix Business Check Score After EWS",
          value: "previousEwsScore"
        },
        { 
          label: "Change",
          value: "changeInScore",
        },
      ],
      EWStable:null,
      filterTableWithCounterpartyName:null,
      isEWSViewReportButtonClicked:"",
      selectedFilterColumn:null,
      selectedMinVal:null,
      selectedMaxVal:null,
      ewsReportList:null,
      ewsReportListError:null,
    };
    
  }

  componentDidMount() {
    let data = getUserInfo();
    this.setState({ userData: data });
    this.props.ewsPublishListRequest({ corporateId: data.corporateId });
    this.props.preloading(true);
  }

  toggleIcon(element) {
    element.preventDefault();
    if (!element.currentTarget.className.includes("open")) {
      element.target.className = "fa fa-minus-square plusIcon";
    } else {
      element.target.className = "fa fa-plus-square plusIcon";
  }
}

  componentDidUpdate(prevProps) {
    let arr = document.getElementsByClassName('rt-expander');
    if(arr.length>0){
    for (const elm of arr) {
    elm.innerHTML = '<i class="fa fa-plus-square plusIcon" aria-hidden="true"></i>';
    elm.addEventListener('click', (e)=>this.toggleIcon(e));
    }
    }
    if (this.props.corporateEWSReport !== prevProps.corporateEWSReport) {
      this.props.preloading(false);
      if (this.props.corporateEWSReport.status === "SUCCESS") {
        let statusCode = this.props.corporateEWSReport.data["status"];
        if (statusCode === 200) {
          const data = this.props.corporateEWSReport.data.data;
          let blob = new Blob([data], { type: "application/octet-stream" });
          fileSaver.saveAs(
            blob,
            `${
              this.state.selectedPublish.label +
              (this.state.isPortfolio ? "_Portfolio" : "_Non_Portfolio")
            }_${moment().format("DD_MMM_YYYY")}.xlsx`
          );
        } else if (statusCode === 204) {
          toast.error(
            <div>
              <i className="fa fa-exclamation-triangle"></i> No data Available
              !!
            </div>
          );
        }
      } else if (this.props.corporateEWSReport.status === "FAILURE") {
        toast.error(
          <div>
            <i className="fa fa-exclamation-triangle"></i> Please Try again !!
          </div>
        );
      }
    }

    if (this.props.publishList != prevProps.publishList) {
      this.props.preloading(false);
      let publishes = [];

      if (this.props.publishList.data != "") {
        this.props.publishList.data.forEach((item) => {
          publishes.push({ value: item.id, label: item.publishName });
        });
      }

      this.setState(
        {
          publishList: publishes,
          publishSelectedOption:
            publishes.length > 0 ? publishes[0] : undefined,
        },
      );
    }

if (
      prevProps.corporateMonitoringData !== this.props.corporateMonitoringData
    ) {
      this.props.preloading(false);

      
    }
    if (this.props.ewsReportList !== prevProps.ewsReportList) {
      this.props.preloading(false);
      this.setState({
        ewsReportList:this.props.ewsReportList,
        EWStable : (<Table 
          data={this.props.ewsReportList}
          columns={this.state.portfolioSelectedOption.value == "Portfolio" ? this.state.columnsForPortfolio : this.state.columnsForNonPortfolio}
          defaultPageSize={50}
          className="-striped -highlight"
          filtered={this.state.filterTableWithCounterpartyName ? [{
            id: 'counterpartyName',
            value: this.state.filterTableWithCounterpartyName
          }] : false}
          SubComponent={({ row }) =>(<Card className="SubTableCard text-center"><CardBody className="SubTableCardBody"><ComplianceCheckScoreTable selectedPortfolio = {this.state.portfolioSelectedOption.value} ewsReportList={this.state.ewsReportList} selectedPublishRow={row._original}/></CardBody></Card>)}
          />
          ),
          isEWSViewReportButtonClicked: true
      })
    }
    if (this.props.ewsReportListError !== prevProps.ewsReportListError) {
      this.setState({
        ewsReportListError:this.props.ewsReportListError
      })
    }
  }

  downloadEWSReport = (e) => {
    this.props.preloading(true);
    var selectedPublishMetadata = this.props.publishList.data.find((obj) => {
      return obj.id === this.state.selectedPublish.value;
    });

    this.setState({
      isPortfolio: this.state.portfolioSelectedOption.value === "Portfolio" ? true : false
    });
    
    this.props.downloadEWSReportRequest({
      corporateId: this.state.userData
        ? this.state.userData.corporateId
        : undefined,
      publishId: this.state.selectedPublish.value,
      publishName: selectedPublishMetadata.publishName,
      fromDate: selectedPublishMetadata.fromDate,
      isPortfolio:
        this.state.portfolioSelectedOption.value === "Portfolio" ? true : false,
    });
  };

callEwsReport=(publishID,selectedPortfolio)=>{
  let isPortfolioSelected = selectedPortfolio === "Portfolio" ? true : false;
    const requestBody = {
      "publishId": publishID,
      "isPortfolio": isPortfolioSelected,
    };
    this.props.listEwsReport(requestBody);
}

  handlePublishChange = (data) => {
    this.setState({
      selectedPublish: data,
    });
  };

  handleselectFilterColumn=(data)=>{
    this.setState({
      selectedFilterColumn:data
    })
  }

  handleEwsViewReport = () => {
    this.props.preloading(true);
    this.clearFilter();
    if(this.state.portfolioSelectedOption.value=="Portfolio"){
      this.setState({
        columnsForDropdown: [
          {
            label: "Rubix Business Check Score",
            value: "latestRubixScore",
          },
          {
            label: "Current Rubix Business Check Score After EWS",
            value: "latestEwsScore"
          },
          {
            label: "Previous Rubix Business Check Score After EWS",
            value: "previousEwsScore"
          },
          { 
            label: "Change",
            value: "changeInScore",
          },
        ]
      })
    }else{
      this.setState({
        columnsForDropdown: [
          {
            label: "Current Rubix Business Check Score After EWS",
            value: "latestEwsScore"
          },
          {
            label: "Previous Rubix Business Check Score After EWS",
            value: "previousEwsScore"
          },
          { 
            label: "Change",
            value: "changeInScore",
          },
        ]
      })
    }
    this.callEwsReport(this.state.selectedPublish.value, this.state.portfolioSelectedOption.value);
  }

  clearFilter =()=>{
     this.setState({
      filterTableWithCounterpartyName:null,
      selectedFilterColumn:null,
      selectedMinVal:null,
      selectedMaxVal:null,
    })
    document.getElementsByClassName('ewsViewFormSerach')[0] && (document.getElementsByClassName('ewsViewFormSerach')[0].value = '');

    return
  }

  setTableFilterByRangeMinVal=(val)=>{
    this.setState({
      selectedMinVal:(val * 1)
    })
  }

  setTableFilterByRangeMaxVal=(val)=>{
    this.setState({
      selectedMaxVal:(val * 1)
    })
  }

  handlePortfolioChange = (data) => {
    if(this.state.isEWSViewReportButtonClicked || this.state.isEWSViewReportButtonClicked ===""){
    this.setState({
      portfolioSelectedOption: data,
    });
  }
  };

  handleFilterByRange=()=>{
    this.setState({
                             EWStable : (<Table 
                              data={this.state.ewsReportList.filter(item=>Number(item[this.state.selectedFilterColumn.value]) >= Number(this.state.selectedMinVal) && item[this.state.selectedFilterColumn.value] <= this.state.selectedMaxVal)}
                              columns={this.state.portfolioSelectedOption.value == "Portfolio" ? this.state.columnsForPortfolio : this.state.columnsForNonPortfolio}
                             defaultPageSize={50}
                             className="-striped -highlight"
                             filtered={this.state.filterTableWithCounterpartyName ? [{
                               id: 'counterpartyName',
                               value: this.state.filterTableWithCounterpartyName
                             }] : false}
                             SubComponent={({ row }) =>(<Card className="SubTableCard text-center"><CardBody className="SubTableCardBody"><ComplianceCheckScoreTable selectedPortfolio = {this.state.portfolioSelectedOption.value} ewsReportList={this.state.selectedFilterColumn ? (this.state.ewsReportList.filter(item=>Number(item[this.state.selectedFilterColumn.value]) >= Number(this.state.selectedMinVal) && item[this.state.selectedFilterColumn.value] <= this.state.selectedMaxVal)): this.state.ewsReportList} selectedPublishRow={row._original}/></CardBody></Card>)}
                              />
                              ),
                             isEWSViewReportButtonClicked: true,
                           });
  }

  setTableFilter = (value) => {
    this.setState({
      filterTableWithCounterpartyName : value,
        EWStable : (<Table 
          data={this.state.ewsReportList}
          columns={this.state.portfolioSelectedOption.value == "Portfolio" ? this.state.columnsForPortfolio : this.state.columnsForNonPortfolio}
          defaultPageSize={50}
          className="-striped -highlight" 
          filtered={value ? [{
            id: 'counterpartyName',
            value: value
          },
        ] : false}
        SubComponent={({ row }) =>(<Card className="SubTableCard text-center"><CardBody className="SubTableCardBody"><ComplianceCheckScoreTable selectedPortfolio = {this.state.portfolioSelectedOption.value} ewsReportList={this.state.ewsReportList} selectedPublishRow={row._original}/></CardBody></Card>)}
                            />
                            ),
        selectedFilterColumn:null,
        selectedMinVal:null,
        selectedMaxVal:null,
    })
    
  }

  render() {
    return (
      <Col>
        <div>
          <Card>
            <CardBody>
              <Row>
                <Col>
                  <Label><h3>EWS Report</h3></Label>
                </Col>
              </Row>
              <Row>
                <Col sm={6}>
                  <Select
                    placeholder={"Select Publish Name"}
                    defaultValue={this.state.selectedPublish}
                    value={this.state.selectedPublish}
                    onChange={this.handlePublishChange}
                    options={this.state.publishList}/>
                </Col>
                <Col sm={4}>
                  <Select
                    placeholder={"Select Type"}
                    defaultValue={this.state.portfolioSelectedOption}
                    value={this.state.portfolioSelectedOption}
                    onChange={this.handlePortfolioChange}
                    options={portfolioOptions}/>
                </Col>
                <Col sm={3}>
                  <Button
                    disabled={!this.state.selectedPublish || !this.state.portfolioSelectedOption}
                    color="primary"
                    onClick={(e) => this.handleEwsViewReport()}>
                    View Report
                  </Button>
                </Col>
                <Col sm={4}>
                  <Button
                    disabled={!this.state.selectedPublish || !this.state.portfolioSelectedOption}
                    color="primary"
                    onClick={(e) => this.downloadEWSReport(e)}>
                    <i className="fa fa-download"></i> Download Report
                  </Button>
                </Col>
              </Row>
            </CardBody>
          </Card>
          <br></br>
          <Row>
            <Col sm={5}>
                {this.state.isEWSViewReportButtonClicked && this.state.EWStable && <input className="ewsViewFormSerach"
                type="text"
                onChange={(e) => this.setTableFilter(e.target.value)}
                placeholder="Search By Counterparty Name..."/>}
            </Col>
            <Col sm={6}>
                {this.state.isEWSViewReportButtonClicked && this.state.EWStable && <Select
                    placeholder={"Select Column To Filter..."}
                    value={this.state.selectedFilterColumn}
                    onChange={this.handleselectFilterColumn}
                    options={this.state.columnsForDropdown}/>}
            </Col>
            <Col sm={3}>
                {this.state.isEWSViewReportButtonClicked && this.state.EWStable && this.state.selectedFilterColumn && <input className="ewsViewFormSerachMinVal"
                type="number"
                name="minValue"
                onChange={(e) => this.setTableFilterByRangeMinVal(e.target.value)}
                placeholder="Enter Min value"/>}
            </Col>
            <Col sm={3}>
                {this.state.isEWSViewReportButtonClicked && this.state.EWStable && this.state.selectedFilterColumn && <input className="ewsViewFormSerachMaxVal"
                type="number"
                name="maxValue"
                onChange={(e) => this.setTableFilterByRangeMaxVal(e.target.value)}
                placeholder="Enter Max value"/>}
            </Col>
            <Col sm={4}>
                {(this.state.isEWSViewReportButtonClicked && this.state.EWStable && this.state.selectedFilterColumn && 
                this.state.selectedMaxVal && this.state.selectedMinVal !== null) ? <Button
                  className="ewsViewFormSerachRangeButton"
                  color="primary"
                  onClick={(e) => this.handleFilterByRange()}>
                  Filter By Range
              </Button> : ""}
            </Col>
          </Row>
          {(this.state.isEWSViewReportButtonClicked && this.state.EWStable) ? this.state.EWStable:""}
          
        </div>
      </Col>
    );
  }
}

const mapStateToProps = (state) => ({
  corporateEWSReport: state.monitoringData.corporateEWSReport,
  corporateMonitoringData: state.monitoringData.corporateMonitoringData,
  publishList: state.monitoringData.publishList,
  ewsReportList: state.ewsReportListReducer.ewsReportList,
  ewsReportListError: state.ewsReportListReducer.ewsReportListError,
});

const mapDispatchToProps = (dispatch) => ({
  preloading: (data) => {
    dispatch(preloading(data));
  },
  downloadEWSReportRequest: (data) => {
    dispatch(downloadEWSReportRequest(data));
  },
  ewsPublishListRequest: (data) => {
    dispatch(ewsPublishListRequest(data));
  },
  fetchCorporateEwsRequest: (data) => {
    dispatch(fetchCorporateEwsRequest(data));
  },
  listEwsReport: (data) => {
    dispatch(listEwsReport(data));
  },
  listEwsReportSuccess: (data) => {
    dispatch(listEwsReportSuccess(data));
  },
  listEwsReportFailure: (data) => {
    dispatch(listEwsReportFailure(data));
  },
});
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(EwsReport)
);
